function fileNameFromPath(string: string) {
  return string.split('\\').pop()?.split('/').pop();
}

export {fileNameFromPath};
